module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (section.name_pl || 'Nowa sekcja')),
        "items": _vm.sections,
        "errors": _vm.checkForErrors(_vm.errors, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          _vm.sections = $event
        }
      }
    })], 1), _vm._v(" "), _c('section-form', {
      attrs: {
        "section": section,
        "fieldTypes": _vm.fieldTypes,
        "errors": _vm.errors[i] || {}
      },
      on: {
        "update:section": function($event) {
          section = $event
        }
      }
    })], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n        dodaj sekcję\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("\n            Sekcje formularza\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4db705ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomForms/Sections.vue
// module id = 752
// module chunks = 0